import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/map.png'


const _withScopeId = n => (_pushScopeId("data-v-0c986b22"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "panel-end-success-inner" }
const _hoisted_2 = { class: "headings-container" }
const _hoisted_3 = { class: "logo-brand" }
const _hoisted_4 = { class: "title-container" }
const _hoisted_5 = { class: "title font-bold" }
const _hoisted_6 = { class: "progress-container" }
const _hoisted_7 = { class: "stats-container" }
const _hoisted_8 = { class: "stats" }
const _hoisted_9 = { class: "stats-title" }
const _hoisted_10 = { class: "font-light" }
const _hoisted_11 = { class: "escape-time" }
const _hoisted_12 = { class: "countdown" }
const _hoisted_13 = { class: "map-container" }
const _hoisted_14 = { class: "map-wrapper" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "map" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "map-img",
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "map-escape-path" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "195",
    height: "490",
    viewBox: "0 0 195 490",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0.371094 398.022H117.624V185.995H192.957V95.4732H60.5163V11.6345",
      stroke: "black",
      "stroke-width": "2.43011",
      "stroke-dasharray": "9.72 19.44"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M60.5176 0.698975L51.5244 13.5394L69.1896 13.5394L60.5176 0.698975Z",
      fill: "#1A1A1A"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "player-spot" })
], -1))
const _hoisted_17 = { class: "map-hotspots-container" }
const _hoisted_18 = { class: "hotspot-details-container" }
const _hoisted_19 = { class: "hotspot-details" }
const _hoisted_20 = { class: "hotspot-details-controls" }
const _hoisted_21 = { class: "cta" }
const _hoisted_22 = ["href"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "all-informations-container" }, null, -1))
const _hoisted_24 = { class: "nav-container" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "escape-path" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    id: "path",
    width: "25",
    height: "78",
    viewBox: "0 0 25 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M1 78L1 1L25 1.00003",
      stroke: "#1A1A1A",
      "stroke-width": "2",
      "stroke-linejoin": "bevel",
      "stroke-dasharray": "8 16"
    })
  ]),
  /*#__PURE__*/_createElementVNode("svg", {
    id: "head",
    width: "10",
    height: "14",
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M10 7.12728L0 4.37114e-07L6.11959e-07 14L10 7.12728Z",
      fill: "#1A1A1A"
    })
  ])
], -1))
const _hoisted_26 = { class: "nav" }

import { computed, ref, onMounted, onUnmounted, nextTick } from 'vue';
import { useI18n } from 'vue-i18n'

import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

import { Hotspot, useHotspots } from '@/services/stores/hotspots'
import { useAppState, useGameState } from '@/services/composition';
import { formatCountdown } from '@/services/states/Utils';
import { MAX_COUNTDOWN } from '@/services/states/GameContextDatas';

import HotspotDetailsItem from './HotspotDetailsItem.vue';
import MapHotspots from './MapHotspots.vue';
import PanelDYK from './PanelDYK.vue';
import Tracking from '@/core/Tracking';
import { Role } from '@/services/states/AppStateMachine';
import UIUserHint from '@/components/UIUserHint/UIUserHint.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

gsap.registerPlugin(ScrollTrigger)

const { t } = useI18n()
const { hotspots } = useHotspots()
const state = useGameState()
const currentIndex = ref(0)
const { send, state: appState } = useAppState()
const showDYK = ref(false)
const showMobileDYK = ref(false)
const showScrollHint = ref(true)

const progress = computed(() => {
  return `--progress: ${(MAX_COUNTDOWN - state.value.context.countdown) / MAX_COUNTDOWN}`
})

const currentHotspots = computed(() => {
  const filtered = hotspots.filter(hotspot => hotspot.isEnd === true) as Hotspot[]
  return filtered
  // return hotspots.filter(hotspot => hotspot.states.some(hState => state.value.matches(hState))) as Hotspot[]
})

const countdown = computed(() => {
  return formatCountdown(MAX_COUNTDOWN - state.value.context.countdown)
})

const prev = () => {
  Tracking.mapSwitchAction()
  currentIndex.value --
  if(currentIndex.value < 0) {
    currentIndex.value = currentHotspots.value.length - 1
  }
}

const next = () => {
  Tracking.mapSwitchAction()
  currentIndex.value ++
  if(currentIndex.value >= currentHotspots.value.length) {
    currentIndex.value = 0
  }
}

const updateIndex = (id: number) => {
  currentIndex.value = currentHotspots.value.findIndex((hotspot: Hotspot) => hotspot.id === id) || 0
}

const isCompanion = computed(() => {
  return appState.value.context.role === Role.Companion
})

const panel = ref(null)
const scrollTrigger = ref(null)
onMounted(async () => {
  await nextTick()
  const $ = gsap.utils.selector(panel.value)
  scrollTrigger.value = ScrollTrigger.create({
    scroller: panel.value,
    trigger: $('.user-hint--scroll .hint-down'),
    start: 0,
    end: `${window.innerHeight + 48}`,
    // markers: true,
    onToggle: () => {
      showScrollHint.value = !showScrollHint.value
    }
  })
})

onUnmounted(() => {
  scrollTrigger.value?.kill()
})

return (_ctx: any,_cache: any) => {
  const _component_ui_icon = _resolveComponent("ui-icon")!
  const _component_ui_btn = _resolveComponent("ui-btn")!
  const _component_ui_btn_icon = _resolveComponent("ui-btn-icon")!

  return (_openBlock(), _createBlock(_Transition, { name: "long-fade" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref_key: "panel",
        ref: panel,
        class: _normalizeClass(["panel-end-success", [_unref(isCompanion) ? 'is-companion' : '']])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, [
              _createVNode(_component_ui_icon, { name: "logo-brand" })
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('end.map.title')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: "progress-bar",
              style: _normalizeStyle(_unref(progress))
            }, null, 4)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(t)('end.map.stats.title')), 1),
                _createVNode(_component_ui_btn, {
                  variant: 'secondary',
                  color: "dark",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showDYK.value = true)),
                  onMouseenter: _cache[1] || (_cache[1] = ($event: any) => {showDYK.value = true; _unref(Tracking).doYouKnow()}),
                  onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (showDYK.value = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('end.map.stats.cta')), 1)
                  ]),
                  _: 1
                }),
                _withDirectives(_createVNode(PanelDYK, {
                  onClose: _cache[3] || (_cache[3] = ($event: any) => (showDYK.value = false))
                }, null, 512), [
                  [_vShow, showDYK.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(countdown)), 1),
                _createVNode(_component_ui_btn, {
                  variant: 'secondary',
                  color: "dark",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (showMobileDYK.value = !showMobileDYK.value))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('end.map.stats.cta')), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _withDirectives(_createVNode(PanelDYK, {
              onClose: _cache[5] || (_cache[5] = ($event: any) => (showMobileDYK.value = false))
            }, null, 512), [
              [_vShow, showMobileDYK.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, [
                _createVNode(MapHotspots, {
                  onUpdate: updateIndex,
                  hotspots: _unref(currentHotspots),
                  active: currentIndex.value
                }, null, 8, ["hotspots", "active"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_ui_btn_icon, {
                  name: "prev",
                  variant: "secondary",
                  color: "dark",
                  "border-position": "bottom-left",
                  onClick: prev
                }),
                _createVNode(_component_ui_btn_icon, {
                  name: "next",
                  variant: "secondary",
                  color: "dark",
                  onClick: next
                })
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentHotspots), (h, i) => {
                return _withDirectives((_openBlock(), _createBlock(HotspotDetailsItem, {
                  key: h.id,
                  hotspot: h
                }, null, 8, ["hotspot"])), [
                  [_vShow, currentIndex.value === i]
                ])
              }), 128)),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("a", {
                  href: _unref(t)('end.map.hotspot.cta_url'),
                  rel: "noreferrer noopener",
                  target: "_blank"
                }, [
                  _createVNode(_component_ui_btn, {
                    variant: "secondary",
                    color: "dark",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(Tracking).learnMore()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('end.map.hotspot.cta')), 1)
                    ]),
                    _: 1
                  })
                ], 8, _hoisted_22)
              ])
            ])
          ]),
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("nav", _hoisted_26, [
              _createVNode(_component_ui_btn, {
                class: "btn-restart",
                color: 'dark-red',
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(send)('GAME_RESTART')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('pause.primary_nav.restart')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ui_btn, {
                color: 'dark',
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(send)('GAME_BACK_HOME')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('pause.primary_nav.home')), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        (showScrollHint.value)
          ? (_openBlock(), _createBlock(UIUserHint, {
              key: 0,
              class: "user-hint--scroll",
              hint: 'down'
            }, {
              title: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('end.hint.title')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _: 1
  }))
}
}

})